// Single source for month-label normalisation — used by chart axes
// (GstChartPrimitives) and the data normalizers so labels stay in sync.

export const MONTH_ABBR = ['Jan', 'Feb', 'Mar', 'Apr', 'May', 'Jun', 'Jul', 'Aug', 'Sep', 'Oct', 'Nov', 'Dec'];

// Normalises API month labels of any common shape ("June 2024", "Jun-2024",
// "Jun2024", "2024-06", "06/2024") to the compact Mmm'YY form used across
// all chart axes; already-short labels pass through unchanged.
export const shortMonthLabel = (label: string): string => {
    const t = String(label ?? '').trim();
    // Month name + year found anywhere in the text — covers "June 2024",
    // "01 Jun 2024", "Jun_2024", "Jun, 2024", "May'26" and similar.
    const mon = /(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)/i.exec(t);
    const y4 = /(20\d{2})/.exec(t);
    const y2 = /['’](\d{2})\b/.exec(t);
    const yy = y4 ? y4[1].slice(2) : y2 ? y2[1] : null;
    if (mon && yy) return `${mon[1][0].toUpperCase()}${mon[1].slice(1).toLowerCase()}'${yy}`;
    const yFirst = /^(\d{4})[-/_](\d{1,2})(?:[-/_]\d{1,2})?/.exec(t); // 2026-05 / 2026-05-01
    if (yFirst) return `${MONTH_ABBR[Math.min(11, Math.max(0, parseInt(yFirst[2], 10) - 1))]}'${yFirst[1].slice(2)}`;
    const mFirst = /^(\d{1,2})[-/_](\d{4})/.exec(t); // 05/2026
    if (mFirst) return `${MONTH_ABBR[Math.min(11, Math.max(0, parseInt(mFirst[1], 10) - 1))]}'${mFirst[2].slice(2)}`;
    return label;
};
